import React, { Component } from 'react'
import { SPORTS } from 'utils/converters'

export default class MatchCell extends Component {
  constructor(props) {
    super(props)
  }

  render() {
    let sport = SPORTS[this.props.sport]
    return (
      <td className='match-cell'>
        <div className='col-xs-12'><strong>{ this.props.homeTeam.toUpperCase() } vs { this.props.awayTeam.toUpperCase() }</strong></div>
        <div className='col-xs-12 league'><i className={ sport.icon }></i> { this.props.league + ' (' + this.props.country + ')'}</div>
      </td>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/mybets/MatchCell.js
 **/